export type CaseStatus = 'open' | 'in_progress' | 'escalated' | 'resolved';
export type CaseTone = 'warning' | 'info' | 'danger' | 'success' | 'neutral';

const LABEL: Record<CaseStatus, string> = {
  open: 'Open', in_progress: 'In progress', escalated: 'Escalated', resolved: 'Resolved',
};

const TONE: Record<CaseStatus, CaseTone> = {
  open: 'warning', in_progress: 'info', escalated: 'danger', resolved: 'success',
};

/** "in_progress" -> "In progress". Unknown statuses are prettified rather than hidden. */
export function caseStatusLabel(status: string): string {
  if (status in LABEL) return LABEL[status as CaseStatus];
  const s = status.replace(/_/g, ' ').trim();
  return s.charAt(0).toUpperCase() + s.slice(1);
}

/** Badge tone for a case status. */
export function caseStatusTone(status: string): CaseTone {
  return status in TONE ? TONE[status as CaseStatus] : 'neutral';
}

/** Lowercase slug (category, outcome) -> "Wellbeing" / "Follow up". */
export function prettifySlug(slug: string | null | undefined): string {
  if (!slug) return '';
  const s = slug.replace(/_/g, ' ').trim();
  return s.charAt(0).toUpperCase() + s.slice(1);
}
